import { ANALYSIS_COLORED_BOX_VARIANTS } from "../../../../../../../lib/analysisColoredBoxVariants";

const getAnalysisColoredBoxVariant = analysisColoredBoxVariant => {
  switch (analysisColoredBoxVariant) {
    case ANALYSIS_COLORED_BOX_VARIANTS.NECESSARY_CONDITION:
      return "yellow";
    case ANALYSIS_COLORED_BOX_VARIANTS.TARGET_LEVEL:
      return "green";
    default:
      return "red";
  }
};

export default getAnalysisColoredBoxVariant;
